import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import PubSub from "pubsub-js";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { MainMapWrapper } from "../components/styled/WebMap.styled";
import { useNavigate } from "react-router-dom";

import Header from "../components/Header";
import LoadWebMap from "./sections/web-map/LoadWebMap";
import { getCurrentUserDetails } from "../services/api/users.api";
import { WEB_MAP_API_TOPIC } from "../constants/WebMap";

export default function WebMapParent() {
  const navigate = useNavigate();
  const [reqCount, setReqCount] = useState(0);

  useEffect(() => {
    const getCurrentUser = async () => {
      try {
        await getCurrentUserDetails();
      } catch (err) {
        if (err.message === "No active account") {
          toast.error("Session Expired, Please Log back", {
            theme: "colored",
          });
          return navigate("/");
        }
      }
    };
    const apiSubscriber = PubSub.subscribe(WEB_MAP_API_TOPIC, (msg, data) => {
      setReqCount(data);
    });
    getCurrentUser();

    return () => {
      PubSub.unsubscribe(apiSubscriber);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <MainMapWrapper data-testid="main-map-wrapper-test">
      <Backdrop
        sx={{ color: "#fff", backgroundColor: "rgba(0,0,0,0.2)", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={reqCount > 0}
      >
        <CircularProgress color="inherit" data-testid="loading-backdrop-test" />
      </Backdrop>
      <Header />
      <LoadWebMap />
    </MainMapWrapper>
  );
}